export const shouldUseNativeDocumentOpen = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768;
};

export const reserveNativeDocumentWindow = () => {
  if (!shouldUseNativeDocumentOpen() || typeof window === 'undefined') return null;

  const opened = window.open('', '_blank');
  if (!opened) return null;

  try {
    opened.opener = null;
    opened.document.title = 'Opening document...';
    opened.document.body.style.margin = '0';
    opened.document.body.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    opened.document.body.innerHTML = `
      <main style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:#F5F0E8;color:#14210B;text-align:center;">
        <div>
          <div style="font-size:16px;font-weight:700;margin-bottom:8px;">Opening document...</div>
          <div style="font-size:14px;line-height:1.5;color:#64748b;">Your browser will open the file as soon as the secure link is ready.</div>
        </div>
      </main>
    `;
  } catch (error) {
    // Cross-browser best effort only; the reserved tab still prevents popup blocking.
  }

  return opened;
};

export const closeReservedDocumentWindow = (reservedWindow) => {
  try {
    if (reservedWindow && !reservedWindow.closed) reservedWindow.close();
  } catch (error) {
    // Best effort cleanup.
  }
};

export const showReservedDocumentWindowError = (reservedWindow, message = 'The document link could not be prepared.') => {
  if (!reservedWindow || reservedWindow.closed) return;

  try {
    reservedWindow.document.title = 'Document unavailable';
    reservedWindow.document.body.style.margin = '0';
    reservedWindow.document.body.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    reservedWindow.document.body.innerHTML = `
      <main style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:#F5F0E8;color:#14210B;text-align:center;">
        <div style="max-width:360px;">
          <div style="font-size:18px;font-weight:800;margin-bottom:8px;">Document unavailable</div>
          <div style="font-size:14px;line-height:1.5;color:#64748b;">${message}</div>
        </div>
      </main>
    `;
  } catch (error) {
    closeReservedDocumentWindow(reservedWindow);
  }
};

export const openDocumentUrlNatively = (url, fileName = 'document', reservedWindow = null) => {
  if (!url || typeof window === 'undefined') return false;

  if (reservedWindow && !reservedWindow.closed) {
    try {
      reservedWindow.location.assign(url);
      return true;
    } catch (error) {
      closeReservedDocumentWindow(reservedWindow);
    }
  }

  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (opened) return true;

  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return true;
};
